import * as types from "./types";

function obtenerBusquedaColegiosEscuelas(payload) {
  return { type: types.OBTENER_BUSQUEDA_INSCRIPCIONES_COLEGIO, payload };
}

function limpiarBusquedaColegiosEscuelas() {
  return { type: types.LIMPIAR_BUSQUEDA_INSCRIPCIONES_COLEGIO };
}

function inscribirEnColegio(payload) {
  return { type: types.INSCRIBIR_EN_COLEGIO, payload };
}

function resetInscribirEnColegio() {
  return { type: types.RESET_INSCRIBIR_EN_COLEGIO };
}

function obtenerDetalleColegio(payload) {
  return { type: types.OBTENER_DETALLE_COLEGIO, payload };
}

function limpiarDetalleColegio() {
  return { type: types.LIMPIAR_DETALLE_COLEGIO };
}

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

/*---*/
export {
  obtenerBusquedaColegiosEscuelas,
  limpiarBusquedaColegiosEscuelas,
  inscribirEnColegio,
  resetInscribirEnColegio,
  obtenerDetalleColegio,
  limpiarDetalleColegio,
  dataSaved,
  resetDataSaved
};



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/actions.js